/**
 * /privacy: the Privacy Policy (docs/refactor/65), readable by anybody — linked from the landing
 * page's footer, the sign-in page, the sign-up box, Conta and the phone app. Signed out it stands
 * alone; signed in it sits inside the app like any other page. The "Excluir sua conta" section has
 * a fixed anchor (/privacy#excluir-conta) because the app store listing points at it.
 */

import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useI18n } from '../lib/i18n'
import { PrivacyText } from '../components/TermsOfUse'

export default function Privacy({ standalone = false }: { standalone?: boolean }) {
  const { t } = useI18n()
  const navigate = useNavigate()
  const location = useLocation()

  // The anchor arrives before the text does: scroll once the section exists.
  useEffect(() => {
    if (!location.hash) return
    const id = location.hash.slice(1)
    const timer = window.setInterval(() => {
      const target = document.getElementById(id)
      if (target) {
        target.scrollIntoView({ block: 'start' })
        window.clearInterval(timer)
      }
    }, 150)
    const stop = window.setTimeout(() => window.clearInterval(timer), 5000)
    return () => {
      window.clearInterval(timer)
      window.clearTimeout(stop)
    }
  }, [location.hash])

  const back = (
    <a
      href={standalone ? '/sign-in' : '/'}
      className="btn btn--ghost btn--sm terms-page__back"
      onClick={(event) => {
        if (window.history.length > 1) {
          event.preventDefault()
          navigate(-1)
        }
      }}
    >
      <ArrowLeft size={14} aria-hidden /> {t('terms.back')}
    </a>
  )

  const content = (
    <div className="terms-page">
      {back}
      <PrivacyText />
      {back}
    </div>
  )

  return standalone ? <div className="terms-page__standalone">{content}</div> : content
}
